export const REDIRECT_PATH_QUERY_KEY = "redirect-path";
